// extracted by css-extract-rspack-plugin
export default {"popover":"q3jn3zZRVI7_3QFq","content":"eamXVZWHNpwseODg","intro":"iwUgA5oE2jvwvGqJ","optionList":"_OuyNXlxwIjkK972","option":"I4QS8M13MhkKHGp5","optionText":"Fv35DiQxJQ5Upr2T"};